import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withActions, isBusy } from 'actionware';
import { getTranslate } from 'react-localize-redux';

import TransactionForm from './transactionForm';
import TransactionTable from './transactionTable';
import { getLenders, getTransactions, setLenderSelected, resetTransaction } from './transactionActions';
import { getLenderId, getRole } from '../../common/helpers';

import './transaction.less'

@connect(({
  localize,
  transaction: { showingTransactionModal, lenders, transactions, summary }
}) => ({
  translate: getTranslate(localize),
  showingTransactionModal,
  lenders,
  transactions,
  summary,
  loading: isBusy(getTransactions)
}))
@withActions({
  getLenders,
  getTransactions,
  setLenderSelected,
  resetTransaction
})
class Transaction extends PureComponent {
  constructor() {
    super();
    this.state = {
      currentLenderId: null,
      role: ''
    }
    this.handleGetTransactions = this.handleGetTransactions.bind(this);
    this.setCurrentLender = this.setCurrentLender.bind(this);
  }
  async componentWillMount() {
    const role = await getRole();
    const lenderId = await getLenderId();
    this.setState({ currentLenderId: lenderId, role });
    this.props.resetTransaction();
    this.props.getLenders();
  }

  handleGetTransactions(lenderId) {
    const { setLenderSelected, getTransactions } = this.props;
    setLenderSelected(lenderId);
    getTransactions({ lender_id: lenderId, page: 1, size: 10, type: 'all' });
  }

  setCurrentLender(lenderId) {
    this.setState({ currentLenderId: lenderId });
  }

  render() {
    const { translate, lenders, transactions, summary, loading } = this.props;
    const { currentLenderId, role } = this.state;
    return (
      <>
        <TransactionForm
          lenders={lenders}
          summary={summary}
          onLenderChange={this.handleGetTransactions}
          setCurrentLender={this.setCurrentLender}
        />
        {
          transactions &&
          <TransactionTable
            translate={translate}
            transactions={transactions}
            summary={summary}
            loading={loading}
            currentLenderId={currentLenderId}
            role={role}
          />
        }
      </>
    )
  }
}

export default Transaction;
